/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkScenarioDependencyRestRequestSchema = z.object({
  hasExactlyOneTarget: z.boolean(),
  itemIds: z
    .array(z.int())
    .min(1)
    .max(2147483647)
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
  predecessorIds: z
    .array(z.int())
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    })
    .nullish(),
  successorIds: z
    .array(z.int())
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    })
    .nullish(),
  waitDays: z.int().min(0).nullish(),
});
